import { css } from 'styled-components';

const BLUR_VALUE = '5px';

export const BLUR_STYLES = css`
  filter: blur(${BLUR_VALUE});
  user-select: none;
`;
